import * as React from 'react';
import styled from '@emotion/styled';
import { blueGray40, dodgerBlue50 } from '@ridi/colors';
import IconWaitFree from 'src/svgs/WaitFree.svg';

interface BadgeProps {
  backgroundColor: string;
  size: number;
};

const Badge = styled.div<BadgeProps>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: ${(props) => props.size}px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: ${(props) => props.backgroundColor};

  & > img, svg {
    width: ${(props) => Math.round(props.size * 20 / 34)}px;
    height: ${(props) => Math.round(props.size * 18 / 34)}px;
  }

  & > span {
    font-size: ${(props) => props.size * 13 / 34}px;
  }
`;

// @ts-ignore
const WaitFree = styled(IconWaitFree)`
  position: relative;
  left: 1px;
  z-index: 2;
`;

const Rentable = styled.span`
  position: relative;
  font-weight: bold;
  line-height: 14px;
  color: #ffffff;
  z-index: 2;
`;

const DiscountPercentage = styled.span`
  top: 1.6px;
  transform: scale(0.92);
  font-weight: bold;
  margin-left: 0.7px;
  font-size: 0.846em;
  position: relative;
  line-height: 0.692em;
`;

const DiscountBadge = styled(Badge)`
  position: relative;
  color: white;
`;

const DiscountNumber = styled.span`
  font-size: 1.231em;
  mix-blend-mode: normal;
  font-weight: bold;
  line-height: 1.077em;
  opacity: 0.99;
`;

interface BookBadgeRendererProps {
  isWaitFree?: boolean;
  isRentable?: boolean;
  discountPercentage?: number;
  size?: number;
}

const BookBadgeRenderer: React.FC<BookBadgeRendererProps> = (props) => {
  const { size = 34, isWaitFree, discountPercentage, isRentable } = props;
  if (isRentable) {
    return (
      // @ridi/colors 패키지 업데이트 후 'sea_green' 으로 바꾸기
      <Badge className="badge" backgroundColor="#3ea590" size={size}>
        <Rentable>대여</Rentable>
      </Badge>
    );
  }
  if (isWaitFree) {
    return (
      <Badge className="badge" backgroundColor={dodgerBlue50} size={size}>
        <WaitFree viewBox="0 0 20 18" preserveAspectRatio="xMidYMid meet" aria-label="리디 기다리면 무료" />
      </Badge>
    );
  }
  if (discountPercentage && discountPercentage >= 10) {
    return (
      <DiscountBadge
        className="badge"
        backgroundColor={blueGray40}
        role="img"
        aria-label={`${discountPercentage}% 할인`}
        size={size}
      >
        <DiscountNumber>{discountPercentage}</DiscountNumber>
        <DiscountPercentage>%</DiscountPercentage>
      </DiscountBadge>
    );
  }
  return null;
};

export default BookBadgeRenderer;



// WEBPACK FOOTER //
// ./components/badge/BookBadgeRenderer.tsx